import React from 'react';
import { Content, Page } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { ArgusEventsTimeline } from '../ArgusEventsTimeline';
import { Box } from '@mui/material';
import { ArgusAppComponentEntity, EKSClusterResourceEntity } from '@eng-portal/czi-extensions-common';

export function ArgusAppEventsEntityTab(): JSX.Element {
  const { entity } = useEntity<ArgusAppComponentEntity>();

  const appName = entity.spec.app?.name;
  if (!appName) {
    throw new Error('App name not found in entity spec');
  }

  return (
    <Page themeId="tool">
      <Content noPadding>
        <Box paddingLeft={5} paddingTop={2} width={'99%'}>
          <ArgusEventsTimeline appName={appName} />
        </Box>
      </Content>
    </Page>
  );
}

export function ArgusClusterEventsEntityTab(): JSX.Element {
  const { entity } = useEntity<EKSClusterResourceEntity>();

  const clusterName = entity.spec.argusCluster?.name;
  if (!clusterName) {
    throw new Error('Cluster name not found in entity spec');
  }

  return (
    <Page themeId="tool">
      <Content noPadding>
        <Box paddingLeft={5} paddingTop={2} width={'99%'}>
          <ArgusEventsTimeline clusterName={clusterName} />
        </Box>
      </Content>
    </Page>
  );
}
